import { render, staticRenderFns } from "./EditItemTypeModal.vue?vue&type=template&id=0630ab09&scoped=true&class=fill-height&"
import script from "./EditItemTypeModal.vue?vue&type=script&lang=ts&"
export * from "./EditItemTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditItemTypeModal.vue?vue&type=style&index=0&id=0630ab09&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630ab09",
  null
  
)

export default component.exports